<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3720_91)">
<path d="M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z" fill="#F0F0F0"/>
<path d="M50 25.0001C50 14.2511 43.2156 5.0874 33.6956 1.55518V48.4453C43.2156 44.9128 50 35.7493 50 25.0001V25.0001Z" fill="#FF9811"/>
<path d="M0 25.0001C0 35.7493 6.78437 44.9128 16.3044 48.4452V1.55518C6.78437 5.0874 0 14.2511 0 25.0001V25.0001Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_3720_91">
<rect width="50" height="50" fill="white"/>
</clipPath>
</defs>
</svg>
